import React from 'react';
import { useVendorForm } from './hooks/useVendorForm';
import Card from '../ui/Card';
import Button from '../ui/Button';
import VendorFormFields from './VendorFormFields';
import { VendorFormProps } from './types';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../ui/Dialog';

interface Props extends VendorFormProps {
  isDialog?: boolean;
}

const VendorFormModal: React.FC<Props> = ({ onClose, onSuccess, isDialog = true }) => {
  const { t } = useTranslation();
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    isValid,
    isSubmitting,
    submitError
  } = useVendorForm(onSuccess);

  const content = (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">{t('vendors.addVendor')}</h2>
        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 hover:text-gray-500"
          aria-label={t('common.close')}
        >
          ×
        </button>
      </div>
      
      {submitError && (
        <div className="text-red-600 text-sm">{submitError}</div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <VendorFormFields
          values={values}
          errors={errors}
          onChange={handleChange}
          disabled={isSubmitting}
        />

        <div className="flex justify-end space-x-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? t('common.loading') : t('common.save')}
          </Button>
        </div>
      </form>
    </div>
  );

  if (!isDialog) {
    return <Card>{content}</Card>;
  }

  return (
    <Dialog onClose={onClose} className="w-full max-w-md">
      {content}
    </Dialog>
  );
};

export default VendorFormModal;